<template>
  <div class="export-import-items">
    <a
      class="btn btn-link text-dark btn-sm mb-0 mr-1"
      :class="{disabled: !hasGeneratedItems}"
      @click="exportGeneratedItems"
      title="Exportar configurações de artefatos para arquivo .json"
    >
      <i class="fa fa-cloud-download mr-1"></i> Exportar
    </a>
    <label
      class="btn btn-link text-dark btn-sm mb-0 mr-1"
      for="importItems"
      title="Importar configurações de artefatos de arquivo .json"
    >
      <i class="fa fa-cloud-upload mr-1"></i> Importar
    </label>
    <input
      class="d-none m-0"
      type="file"
      id="importItems"
      @change="importItems($event.target)"
      :multiple="false"
      lang="pt-br"
      accept=".json"
      hidden
    />
    <a
      class="btn btn-link text-danger btn-sm mb-0"
      @click="removeGeneratedItems"
      :hidden="!hasGeneratedItems"
    >
      <i class="fa fa-trash mr-2"></i> Destruir artefatos
    </a>
  </div>
</template>

<script>
  import { mapActions, mapMutations, mapGetters } from 'vuex';

  export default {
    name: 'ExportImportItems',
    computed: {
      ...mapGetters([ 'hasGeneratedItems' ])
    },
    methods: {
      ...mapActions([
        'exportGeneratedItems',
        'importGeneratedItems'
      ]),
      ...mapMutations({
        removeGeneratedItems: 'REMOVE_GENERATED_ITEMS'
      }),
      importItems ({ files }) {
        this.importGeneratedItems(files[0]);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .pointer {
    cursor: pointer;
  }
</style>